import { useContext } from 'react';
import DataContext from '../Contexts/DataContext';

export default function useApplicationConfig() {
  const { applicationConfig } = useContext(DataContext);
  return applicationConfig;
}
